import {
    createAPIConfigForDeleteTagGroup,
    createAPIConfigForGetTagGroup,
} from '@domain/segments/segments.api';
import { createReducer, INITIAL_STATE } from '@shared/redux';
import { INITIAL_SELECTED_GROUP } from '@shared/constants/dashboard/campaign-table-constants';
import { LOAD_STATE } from '@shared/axios/axios.constants';
import {
    convertSegmentPayload,
    convertSegmentsTaggedCampaignsToMap,
    getGroupBySlug,
} from '@domain/segments/segments.utils';

export const GET_SEGMENTS_REQUEST_CALLED = '@segments/GET_SEGMENTS_REQUEST_CALLED';
export const GET_SEGMENTS_REQUEST_SUCCEEDED = '@segments/GET_SEGMENTS_REQUEST_SUCCEEDED';
export const GET_SEGMENTS_REQUEST_FAILED = '@segments/GET_SEGMENTS_REQUEST_FAILED';

export const DELETE_SEGMENT_REQUEST_CALLED = '@segments/DELETE_SEGMENT_REQUEST_CALLED';
export const DELETE_SEGMENT_REQUEST_SUCCEEDED = '@segments/DELETE_SEGMENT_REQUEST_SUCCEEDED';
export const DELETE_SEGMENTS_REQUEST_FAILED = '@segments/DELETE_SEGMENTS_REQUEST_FAILED';

export const SET_SELECTED_SEGMENT = '@segments/SET_SELECTED_SEGMENT';
export const SET_SELECTED_SEGMENT_BY_SLUG = '@segments/SET_SELECTED_SEGMENT_BY_SLUG';
export const INSERT_SEGMENT = '@segments/INSERT_SEGMENT';
export const EDIT_SEGMENT = '@segments/EDIT_SEGMENT';

export const getSelectedGroup = state => state.segments.currentSegments.selectedGroup;
export const getCurrentTagGroups = state => state.segments.currentSegments;

export const getClientTagGroups = ({
    clientId,
}) => ({
    type: GET_SEGMENTS_REQUEST_CALLED,
    actionTypes: {
        success: GET_SEGMENTS_REQUEST_SUCCEEDED,
        fail: GET_SEGMENTS_REQUEST_FAILED,
    },
    config: createAPIConfigForGetTagGroup({ client_id: clientId }),
});

export const setSelectedGroup = ({ group }) => ({
    type: SET_SELECTED_SEGMENT,
    payload: {
        group,
    },
});

export const setSelectedGroupBySlug = ({ groupSlug }) => ({
    type: SET_SELECTED_SEGMENT_BY_SLUG,
    payload: {
        groupSlug,
    },
});

export const insertGroup = ({ group }) => ({
    type: INSERT_SEGMENT,
    payload: {
        group,
    },
});

export const editGroup = ({ group }) => ({
    type: EDIT_SEGMENT,
    payload: {
        group,
    },
});

export const deleteTagGroup = ({
    clientId, groupSlug, groupId,
}) => ({
    type: DELETE_SEGMENT_REQUEST_CALLED,
    actionTypes: {
        success: DELETE_SEGMENT_REQUEST_SUCCEEDED,
        fail: DELETE_SEGMENTS_REQUEST_FAILED,
    },
    payload: {
        clientId, groupSlug,
    },
    config: createAPIConfigForDeleteTagGroup({
        client_id: clientId,
        id: groupId,
    }),
});

const removeGroupBySlug = (tagsGroups, groupSlug) => tagsGroups.filter(
    tagGroup => tagGroup.slug !== groupSlug,
);

const initialState = {
    loadState: LOAD_STATE.LOADING,
    data: [],
    error: null,
    selectedGroup: INITIAL_SELECTED_GROUP,
};

export const currentSegmentsReducers = createReducer({
    [INITIAL_STATE]: initialState,
    [GET_SEGMENTS_REQUEST_CALLED]: state => ({
        ...state,
        loadState: LOAD_STATE.LOADING,
        data: [],
        error: null,
    }),
    [GET_SEGMENTS_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.SUCCESS,
        data: convertSegmentsTaggedCampaignsToMap(action.payload.data),
        error: null,
    }),
    [GET_SEGMENTS_REQUEST_FAILED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.FAIL,
        data: [],
        error: action.payload,
    }),
    [DELETE_SEGMENT_REQUEST_CALLED]: state => ({
        loadState: LOAD_STATE.LOADING,
        ...state,
    }),
    [DELETE_SEGMENT_REQUEST_SUCCEEDED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.SUCCESS,
        data: removeGroupBySlug(state.data, action.requestAction.payload.groupSlug),
        error: null,
    }),
    [DELETE_SEGMENTS_REQUEST_FAILED]: (state, action) => ({
        ...state,
        loadState: LOAD_STATE.FAIL,
        error: action.payload,
    }),
    [SET_SELECTED_SEGMENT]: (state, action) => ({
        ...state,
        selectedGroup: action.payload.group,
    }),
    [INSERT_SEGMENT]: (state, action) => ({
        ...state,
        data: [...state.data, convertSegmentPayload(action.payload.group)],
    }),
    [EDIT_SEGMENT]: (state, action) => ({
        ...state,
        data: state.data.map(
            (tagGroup) => {
                if (tagGroup.slug === action.payload.group.slug) {
                    return convertSegmentPayload(action.payload.group);
                }
                return tagGroup;
            },
        ),
    }),
    [SET_SELECTED_SEGMENT_BY_SLUG]: (state, action) => ({
        ...state,
        selectedGroup: getGroupBySlug(state.data, action.payload.groupSlug),
    }),
});
